<template>
  <div class="panel" id="dishOptionsScrollContainer">
    <div class="poster-overlay" v-if="blockPriceEdit">
      {{ $t('menu_settings.poster_locked') }}
    </div>
    <div class="dish-variants-edit" v-if="!blockPriceEdit">
      <h2>{{$t('menu_editor.variants')}}:</h2>
      <div class="dish-variants" v-if="dish.price_groups[0].items.length > 1">
        <div class="extra columns" v-for="(item,index) in dish.price_groups[0].items" :key="index">
          <form @submit.prevent>
            <div class="d-flex align-items-end">
              <input
                :class="{
                  'price-variant': true,
                  'invalid-input': !valid && !item.name
                }"
                :placeholder="$t('menu_editor.variant')"
                type="text"
                v-model="item.name"
                @keyup.enter="showAddVariantUI"
              />
              <button
                class="variant-delete small"
                type="button"
                @click="onRemoveVariant(index)"
                v-if="index != 0 && !blockPriceEdit"
              ></button>
            </div>
            <div class="d-flex">
              <input
                class="price-value weight-size ml-0"
                :placeholder="dish.unit == 'g' ? $t('menu_settings.weight') : $t('menu_settings.volume')"
                type="number"
                v-model.number="item.weight"
              />
              <input
                :class="{
                  'price-value': true,
                  'w-25': true,
                  'invalid-input': !valid && item.price === null
                }"
                :placeholder="$t('menu_editor.price')"
                type="number"
                v-model.number="item.price"
                :disabled="blockPriceEdit"
              />
            </div>
          </form>
        </div>
      </div>
      <div class="new-variant" v-if="add_variant.active">
        <form @submit.prevent="onAddVariant">
          <input class="price-variant" type="text" v-model="add_variant.name" />
          <input class="price-value" type="number" v-model="add_variant.price" />
          <button value="submit" class="variant-confirm"></button>
        </form>
      </div>

      <button
        class="dish-variants-add"
        @click="showAddVariantUI"
        v-if="!add_variant.active"
      >+{{$t('menu_editor.new_variant')}}</button>
    </div>
    <div :class="!blockPriceEdit ? 'dish-modificators-edit':'dish-modificators-edit mt-0'" v-if="!blockPriceEdit">
      <h2>{{$t('menu_editor.additions')}}:</h2>
      <div class="extra" v-for="(item,index) in dish.price_groups[1].items" :key="index">
        <form @submit.prevent>
          <input
            type="text"
            :class="{
              'price-variant': true,
              'invalid-input': !valid && !item.name
            }"
            v-model="item.name"
            @keyup.enter="onModificatorFormSubmit"
            :placeholder="$t('menu_editor.addition')"
          />
          <!-- <ModificatorAutocomplete
            :value="mod.name"
            @select="mod => onModificatorAutocomplete(mod, index)"
          /> -->
          <input
            :class="{
              'price-value': true,
              'invalid-input': !valid && item.price === null
            }"
            type="number"
            v-model.number="item.price"
            :placeholder="$t('menu_editor.price')"
            @keyup.enter="onModificatorFormSubmit"
          />
          <input
            class="price-value"
            type="number"
            v-model.number="item.weight"
            :placeholder="dish.unit == 'g' ? $t('menu_settings.weight') : $t('menu_settings.volume')"
            @keyup.enter="onModificatorFormSubmit"
          />
          <button
            class="variant-delete modificator-delete"
            type="button"
            @click="onRemoveModificator(index)"
          ></button>
        </form>
      </div>

      <div class="new-variant" v-if="add_modificator.active">
        <form @submit.prevent="onAddModificator">
          <input class="price-variant" type="text" required v-model="add_modificator.name" />
          <input class="price-value" type="number" required v-model="add_modificator.price" />
          <button value="submit" class="variant-confirm"></button>
        </form>
      </div>
      <button
        class="dish-modificators-add"
        @click="showAddModificatorUI"
        v-if="!add_modificator.active"
      >+{{$t('menu_editor.new_addition')}}</button>
    </div>
  </div>
</template>

<script>
import ModificatorAutocomplete from "@/components/menu/ModificatorAutocomplete.vue";

export default {
  data() {
    return {
      add_variant: {
        active: false,
        name: null,
        price: null
      },

      add_modificator: {
        active: false,
        name: null,
        price: null
      }
    };
  },
  props: {
    valid: Boolean
  },
  methods: {
    onAddVariant() {
      if (!this.add_variant.name || !this.add_variant.price) {
        this.hideAddVariantUI();
        return;
      }

      this.$store.commit("menu/addVariant", {
        id: this.dish._id,
        variant: this.add_variant.name,
        value: this.add_variant.price
      });
      this.hideAddVariantUI();
    },
    onAddModificator() {
      if (!this.add_modificator.name || !this.add_modificator.price) {
        this.hideAddModificatorUI();
        return;
      }

      this.$store.commit("menu/addModificator", {
        id: this.dish._id,
        name: this.add_modificator.name,
        price: this.add_modificator.price,
        weight: null
      });
      this.hideAddModificatorUI();
    },
    showAddVariantUI() {
      // this.add_variant.name = null;
      // this.add_variant.active = true;
      // this.add_variant.price = null;
      this.$store.commit("menu/addVariant", {
        id: this.dish._id,
        name: null,
        price: null,
        weight: null
      });

      this.$nextTick(() => {
        const el = document.getElementById("dishOptionsScrollContainer");
        el.scrollTop = el.scrollHeight;
      });
    },
    showAddModificatorUI() {
      // this.add_modificator.name = null;
      // this.add_modificator.active = true;
      // this.add_modificator.price = null;
      this.$store.commit("menu/addModificator", {
        id: this.dish._id,
        name: null,
        price: null,
        weight: null
      });

      this.$nextTick(() => {
        const el = document.getElementById("dishOptionsScrollContainer");
        el.scrollTop = el.scrollHeight;
      });
    },
    onModificatorFormSubmit() {
      this.showAddModificatorUI();
    },
    hideAddVariantUI() {
      this.add_variant.active = false;
    },
    hideAddModificatorUI() {
      this.add_modificator.active = false;
    },
    onRemoveVariant(index) {
      this.$store.commit("menu/removePriceGroupItem", {
        id: this.dish._id,
        group_index: 0,
        item_index: index
      });
    },
    onRemoveModificator(index) {
      this.$store.commit("menu/removePriceGroupItem", {
        id: this.dish._id,
        group_index: 1,
        item_index: index
      });
    },

    convertDescriptionToIngredients() {
      const desc = this.dishDescription;

      const comma_index = desc.indexOf(",");

      if (comma_index == -1) {
        alert(
          `Здається, коми відсутні в описі, конвертувати в інгрідієнти неможливо.`
        );
        return;
      }

      const tokens = desc.split(",").map(s => s.trim());

      this.dishDescription = "";
      this.dishIngredients = tokens;
    },
    onModificatorAutocomplete(mod, index) {
      this.dish.modificators[index].name = mod.name;
      this.dish.modificators[index].price = mod.price;
    }
  },
  computed: {
    dish() {
      return this.$store.state.menu.product;
    },
    dishName: {
      get() {
        return this.dish.name;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "name",
          value
        });
      }
    },
    dishDescription: {
      get() {
        return this.dish.description;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "description",
          value
        });
      }
    },
    dishIngredients: {
      get() {
        return this.dish.ingredients;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "ingredients",
          value
        });
      }
    },
    dishWeight: {
      get() {
        return this.dish.weight;
      },
      set(value) {
        this.$store.commit("menu/setProductData", {
          key: "weight",
          value
        });
      }
    },
    isAllowedToConvertDescription() {
      return this.$route.query.dikey && this.$route.query.dikey == "hd20dnc2";
    },
    blockPriceEdit() {
      return this.hasPosterIntegration && this.dish.poster_product_id;
    },
    hasPosterIntegration() {
      return this.$store.getters.hasPosterIntegration;
    },
    isSinglePriceOnly() {
      const variants_group = this.dish.price_groups.filter(g => g.single_select);
      return variants_group.length == 1 && variants_group[0].items.length == 1;
    }
  },
  components: {
    ModificatorAutocomplete
  }
};
</script>

<style scoped>
.panel {
  overflow-y: auto;
  height: 70vh;
  width: 37.3vh;
  background: #1d1d1b;
  border-radius: 1.5vh;
  margin: 5vh 5.5vh 0 0;
  padding: 2vh 2vh 3vh;
}

input {
  margin-top: 1vh;
}

.weight-select {
  margin-left: 0.6vh;
}

.w-60 {
  width: 60% !important;
}

.blur {
  filter: blur(2px);
}

.dish-variants-edit {
  margin: 0;
  display: grid;
}
.dish-modificators-edit {
  display: grid;
  margin: 2.2vh 0 0 0;
}

.dish-variants-edit h2,
.dish-modificators-edit h2,
h5 {
  font-weight: 500;
  font-size: 1.8vh;
  color: #ededed;

  margin-bottom: 0vh;
}

.dish-variants-add,
.dish-modificators-add {
  width: 100%;
  height: 3.2vh;
  margin-top: 1.2vh;
  border: 0.06vw solid #cbd9e6;
  box-sizing: border-box;
  border-radius: 0.33vw;

  font-weight: 500;
  font-size: 1.5vh;

  color: #cbd9e6;
  background: none;

  cursor: pointer;
}
.extra form {
  display: flex;
  position: relative;
}

.extra.columns form {
  flex-flow: column nowrap;
}

.price-variant {
  width: 100%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;
  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;
  padding: 0.5vh;
}

.weight-size {
  width: 73% !important;
}

.price-value {
  padding: 0.5vh;

  width: 50%;
  height: 3.4vh;

  background: #ededed;
  border-radius: 0.5vh;

  font-weight: 500;
  font-size: 1.7vh;
  border: 0;
  outline: none;

  color: #1d1d1b;

  margin-left: 0.5vh;
}

.variant-delete {
  background: url("../../assets/delete.png") center #e2223b no-repeat;
  background-size: 1.6vh;
  border: 0;
  border-radius: 0.5vh;
  margin-left: 0.5vh;
  width: 18.3%;
  margin-top: 1vh;
  height: 3.4vh;
  cursor: pointer;
}

.variant-delete.small {
  width: 11.5%;
}

.variant-confirm {
  background: url("../../assets/accept.png") center #129b81 no-repeat;

  width: 2.22vw;
  height: 2.22vw;
  border: 0;
  border-radius: 1vh;
  margin-left: 0.6vh;
  background-size: 1.18vw;
  cursor: pointer;
}

.new-variant form {
  display: flex;
}

.upload-button {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  display: inline-block;
  margin: 0 auto;
  width: 85%;
  border: 0;
  color: #fff;
  border-radius: 0.8vw;
  font-weight: bold;
  font-size: 1vw;
  cursor: pointer;
  background-color: #464646;
}

.weighted-select {
  margin-left: 0 !important;
  margin-top: 0.5vh;
}

.card-ingredients-input {
  margin-bottom: 1vh;
}

.modificator-delete {
  width: 8.4vh;
  height: 3.4vh;
}

.invalid-input {
  border: 2px solid #e2223b;
}

.poster-overlay {
  width: 100%;
  height: 100%;

  text-align: center;
  background: #1d1d1b;

  color: #ededed;
  font-size: 2.2vh;

  position: relative;
  z-index: 50;

  display: flex;
  align-items: center;
}
</style>
